export const tagType = {
	team_tag: "TEAM_TAG",
	player_tag: "PLAYER_TAG",
	chart_tag: "CHART_TAG",
	widget_tag: "WIDGET_TAG",
	stat_tag: "STAT_TAG",
};
